import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import { useSubheader } from "../../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1 } from "../../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import xlsxFile from "read-excel-file";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import exceltemplate from './excelTemplate/TemplateSendingCode.xlsx'
import { tr } from "date-fns/locale";

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export const ImportSendCoupon = () => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(1000);
  const suhbeader = useSubheader();
  suhbeader.setTitle("Import Send Coupon");
  const { authToken } = useSelector((state) => state.auth);
  const [showUpload, setShowUpload] = React.useState(false);

  const history = useHistory();
  const [rows, setRows] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [importFile, setImportFile] = React.useState();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };

  const handleUplodaFile = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      setImportFile(file)
      excelReadFile(file)
      e.target.value = ''
    }
  };

  const checkWhiteList = (data) => {
    if (data[1] != "Cart ID") {
      return false
    } else if (data[2] != "Email") {
      return false
    } else if (data[3] != "Delivery Name") {
      return false
    } else if (data[6] != "Contact No.") {
      return false
    } else if (data[16] != "Cart Status") {
      return false
    } else if (data[23] != "Prod 1 Code") {
      return false
    } else if (data[24] != "Prod 1 Qty") {
      return false
    }
    return true
  }

  const checkColumn = (data) => {
    if (data == "Cart ID") {
      return true
    } else if (data == "Email") {
      return true
    } else if (data == "Delivery Name") {
      return true
    } else if (data == "Contact No.") {
      return true
    } else if (data == "Cart Status") {
      return true
    } else if (data == "Prod 1 Code") {
      return true
    } else if (data == "Prod 1 Qty") {
      return true
    }
    return false
  }

  const excelReadFile = async (file) => {
    var importRows = []
    var importColumns = []
    setShowUpload(false)
    await xlsxFile(file).then(async (rows) => {
      if (!checkWhiteList(rows[0])) return AlertError("Template invalid !!")
      for (let index = 0; index < rows.length; index++) {
        const element = rows[index];
        if (index == 0) {
          for (let cindex = 0; cindex < element.length; cindex++) {
            const columns = element[cindex];
            if (checkColumn(columns)) {
              importColumns.push({ id: cindex, label: columns, minWidth: 100 })
            }
          }
        } else {
          importRows.push(element)
        }
      }
      setColumns(importColumns)
      setRows(importRows)
      if (importRows.length > 0) setShowUpload(true)
    });



  };

  const handleConfirm = () => {
    Swal.fire({
      title: "ยืนยันกาทำรายการ?",
      text: "ยืนยันการนำเข้าข้อมูล!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        var data = []
        for (let i = 0; i < rows.length; i++) {
          const cdata = rows[i];
          var object = {}
          for (let r = 0; r < cdata.length; r++) {
            object = {
              mobile: cdata[6],
              email: cdata[2],
              coupon_code: cdata[23],
              coupon_qty: cdata[24],
              cart_id: cdata[1],
              cart_status: cdata[16],
              delivery_name: cdata[3]
            }
          }
          data.push(object)
        }
        let events = {
          importList: JSON.stringify(data),
          importName: importFile.name,
          importTotalRecord: rows.length
        };
        let token = localStorage.getItem("Token");
        return axios({
          method: "post",
          url: `${baseURLV1}/coupon/import`,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: events,
        }).then(async (res) => {
          return res
        }).catch((err) => {
          Swal.showValidationMessage(
            `ทำรายการไม่สำเร็จ: ${err}`
          )
        });
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        if (result.isConfirmed) {
          Swal.fire("แจ้งเตือน", "ทำรายการสำเร็จเรียบร้อย", "success");
          history.goBack()
        }

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("แจ้งเตือน", "ยกเลิกการทำรายการ", "error");
      }
    })
  }

  return (
    <Card>
      <CardHeader title="Import Send Coupon">
        <CardHeaderToolbar>
          <a
            href={exceltemplate}
            target="_blank"
            download="exceltemplate"
          >
            <button type="button" className="btn btn-primary">
              Example Template
            </button>
          </a>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="d-flex justify-content-between">
              <div className="form-group">
                <span className="btn btn-primary btn-file wbt">
                  <input type="file" onChange={handleUplodaFile} />
                </span>

              </div>
              {showUpload &&
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-success m-1"
                    onClick={() => handleConfirm()}
                  >
                    Confirm Import
                  </button>
                </div>
              }
            </div>
          </div>

        </div>


        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </CardBody>
    </Card>
  );
};
